// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0866af94","598":"295289a2","703":"88986122","787":"7a47dc29"}[chunkId] + ".chunk.js";
};